import $ from 'jquery';

$('body').on('click', 'a', (e) => {
  if (e.currentTarget.pathname != window.location.pathname) {
    return;
  }
  const $element = $(e.currentTarget);

  if (e.currentTarget.dataset.toggle == 'collapse' ||
    e.currentTarget.dataset.toggle == 'tab'
  ) {
    return;
  }
  if (e.currentTarget.dataset.slide) {
    return;
  }
  const hash = e.currentTarget.hash;
  if (hash) {
    scrollTo(hash, e);
  }
});

$(document).ready((e) => {
  const hash = window.location.hash;
  if (hash) {
    setTimeout(() => {
      scrollTo(hash, false, false);
    }, 100);
  }
});

const scrollTo = (id, e = null, anim = true) => {
  if ($(id).length > 0) {
    if (e) {
      e.preventDefault();
    }
    const headerHeight = $('.js-fixed-top').height();
    const scrollPosition = $(id).offset().top - headerHeight - 30;
    if (anim) {
      $('html,body').animate({
        scrollTop: scrollPosition
      }, 400);
    } else {
      window.scrollTo({
        top: scrollPosition
      })
    }
    // $('html,body').scrollTop(scrollPosition);
  }
}